<template>
  <component
    :is="tag || 'time'"
    v-bind="$attrs"
    :key="date"
    v-thtml="formattedDate"
    :datetime="tag || !datetime ? false : datetime"
  />
</template>
<script setup lang="ts">
const dateFormatsMap: Record<string, Intl.DateTimeFormatOptions> = {
  day: { day: 'numeric' },
  month: { month: 'long' },
  year: { year: 'numeric' },
  fullDateTime: {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  },
  dayMonth: { month: 'short', day: 'numeric' },
  full: { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' },
  long: { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' },
  short: { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit' },
  noYear: { weekday: 'short', day: 'numeric', month: 'short' },
  noDay: { month: 'short', year: 'numeric' },
  time: { hour: 'numeric', minute: 'numeric' },
  numeric: { day: 'numeric', month: 'numeric', year: 'numeric' },
}

const { $i18n } = useNuxtApp()

const props = defineProps<{
  date: string
  tag?: string
  options?: Record<string, Intl.DateTimeFormatOptions> | string
}>()

const datetime = computed(() => {
  if (!props.date) {
    return
  }
  return new Date(props.date).toISOString()
})

const option = computed(() => {
  return typeof props.options === 'string'
    ? dateFormatsMap[props.options]
    : props.options
})

const formattedDate = computed(() => {
  if (!props.date) {
    return ''
  }
  return Intl.DateTimeFormat($i18n.locale, option.value).format(
    new Date(props.date),
  )
})
</script>
